import React from 'react'

import HeaderLayout from 'components/Layout/Header'
import SelectInHeader from 'components/SelectOptions/SelectInHeader'

import type { UseWarehouseSelectionReturn } from '../hooks/useWarehouseSelection'

// 倉庫 / テナント選択は親（index.tsx）で useWarehouseSelection を実行し props で受け取る。
// 一覧取得（useDeliveryPerformanceListController）と同じ tenantId を共有するため合成を持ち上げている。
type Props = Pick<
  UseWarehouseSelectionReturn,
  | 'warehouseId'
  | 'tenantId'
  | 'warehouseOptions'
  | 'tenantOptions'
  | 'changeWarehouseId'
  | 'changeTenantId'
>

export const DeliveryPerformanceListHeader: React.FC<Props> = ({
  warehouseId,
  tenantId,
  warehouseOptions,
  tenantOptions,
  changeWarehouseId,
  changeTenantId,
}) => {
  return (
    <HeaderLayout>
      <div className="d-flex w-100 justify-content-end">
        <SelectInHeader
          className="ml-3"
          width="180px"
          options={warehouseOptions}
          value={warehouseId ?? ''}
          placeholder="倉庫名"
          onChange={(newOption: { value: number }) => {
            if (newOption) {
              changeWarehouseId(newOption.value)
            }
          }}
        />
        <SelectInHeader
          className="ml-3"
          width="180px"
          options={tenantOptions}
          value={tenantId ?? ''}
          placeholder="テナント名"
          onChange={(newOption: { value: number }) => {
            if (newOption) {
              changeTenantId(newOption.value)
            }
          }}
        />
      </div>
    </HeaderLayout>
  )
}
